import { Component } from '@angular/core';
import { ModalController,NavController, Platform, NavParams, ViewController } from 'ionic-angular';
import { datos } from '../../providers/datos';
import { Detalle } from '../detalle/detalle';
import moment from 'moment';




declare var document:any;

declare var swal:any;
declare var $:any;



@Component({
  selector: 'mis_servicios',
  templateUrl: 'mis_servicios.html',
})
export class mis_servicios {
 
menu="hoy";
hora:any;
fecha:any;
item= {
"id":"",
"nombre":"",
"cantidad":1,
"valor":0,
"fecha":"",
"hora":"",
"img":"assets/images/servicios/manos.jpg",
"des":"sasasasasas"
};

  constructor(   
   public viewCtrl: ViewController,
   public params: NavParams,
   private datos:datos,

    public modalCtrl: ModalController,
    public navParams: NavParams,
    public navCtrl: NavController
  



   ) {
    var a = function add() {
    alert();
    }
  //  let temp =   this.navParams.get('item');
    // this.producto= this.params.get('producto');
    //  this.item= temp;
      
    //  console.log( temp);

  }

  ionViewDidLoad() {
    // var _hora = moment(hora,'HH:mm').locale('es');
    // var actual = moment(moment().format('HH:mm:ss'),'HH:mm').locale('es');


    this.hora = String(moment().format('HH:mm'));
    this.fecha = String(moment().format('YYYY-MM-DD'));

    console.log(this.fecha);
    // let dif = _hora.diff(actual,'minutes');

    this.item.hora=String(this.hora);
    this.item.fecha=String(this.fecha);


  }


  detalle() {

  
  
  }


  calificar(){

    let resultado =-1;
    let wrap = document.createElement('div');
    wrap.setAttribute('class', 'text-muted');
    wrap.innerHTML = ' <button clear id="b1" type="button" value="sad" class="btn feel"><i class="fa fa-frown-o fa-3x"></i></button><button id="b2" type="button" value="neutral" class="btn feel"><i class="fa fa-meh-o fa-3x"></i></button><button id="b3" type="button" value="happy" class="btn feel"><i class="fa fa-smile-o fa-3x"></i></button><button id="b4" type="button" value="happy" class="btn feel"><i class="fa fa-heart-o fa-3x"></i></button><hr>'
    
    swal({
      title: "Pregunta #1",
      text: "Cómo fue atendido por el especialista?",
      icon: "info",
      className: '',
      closeOnClickOutside: false,
      content: {
        element: wrap
      },
      buttons: {
        confirm: {
          text: "OK",
          value: '',
          visible: true,
          className: "btn btn-default",
          closeModal: true,
        }
      },
    }).then((value) => {

      // alert(resultado);
      if(resultado==-1){this.calificar()}
      else {

        swal("Responde la pregunta #2", {
              icon: "warning",
              title: "Gracias!",
               buttons: {
                confirm: {
                  text: "OK",
                  value: '',
                  visible: true,
                  className: "btn btn-default",
                  closeModal: true,
                }}
          }).then(() => {
            this.pregunta2();

          })
      }


      // if (value === 'sad') {
      //   swal("Sorry!", {
      //     icon: "error",
      //     buttons: false
      //   });
      // } else if (value === 'neutral') {
      //   swal("Okay!", {
      //     icon: "warning",
      //     buttons: false
      //   });
      // } else if (value === 'happy') {
      //   swal("Hooray!", {
      //     icon: "success",
      //     buttons: false
      //   });
      // }
    });


    $( "#b0" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b0" ).addClass("opaco");
    resultado =0;
    });

    $( "#b1" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b1" ).addClass("opaco");
    resultado =1;
    
  });


  $( "#b2" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b2" ).addClass("opaco");
  resultado =2;
    
});


$( "#b3" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b3" ).addClass("opaco");
resultado =3;
});
  
$( "#b4" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b4" ).addClass("opaco");
resultado =4;
});
  

  }
  



///   PREGUNTA 22


pregunta2(){

  let resultado =-1;
  let wrap = document.createElement('div');
  wrap.setAttribute('class', 'text-muted');
  wrap.innerHTML = ' <button clear id="b1" type="button" value="sad" class="btn feel"><i class="fa fa-frown-o fa-3x"></i></button><button id="b2" type="button" value="neutral" class="btn feel"><i class="fa fa-meh-o fa-3x"></i></button><button id="b3" type="button" value="happy" class="btn feel"><i class="fa fa-smile-o fa-3x"></i></button><button id="b4" type="button" value="happy" class="btn feel"><i class="fa fa-heart-o fa-3x"></i></button><hr>'
  
  swal({
    title: "Pregunta #2",
    text: "Pregunta 2?",
    icon: "info",
    className: '',
    closeOnClickOutside: false,
    content: {
      element: wrap
    },
    buttons: {
      confirm: {
        text: "OK",
        value: '',
        visible: true,
        className: "btn btn-default",
        closeModal: true,
      }
    },
  }).then((value) => {
    if(resultado==-1){this.pregunta2()}
    else {
      swal("Responde la pregunta #3", {
        icon: "warning",
        title: "Gracias!",
         buttons: {
          confirm: {
            text: "OK",
            value: '',
            visible: true,
            className: "btn btn-default",
            closeModal: true,
          }}
    }).then(() => {
      this.pregunta3();

    })
    }


  });


  $( "#b1" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b1" ).addClass("opaco");
  resultado =0;
  });

  $( "#b2" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b2" ).addClass("opaco");
  resultado =1;
  
});


$( "#b3" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b3" ).addClass("opaco");
resultado =2;
  
});


$( "#b4" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b4" ).addClass("opaco");
  
});

}


//FIN PREGUNTA 2



//   PREGUNTA 3


pregunta3(){

  let resultado =-1;
  let wrap = document.createElement('div');
  wrap.setAttribute('class', 'text-muted');
  wrap.innerHTML = ' <button clear id="b1" type="button" value="sad" class="btn feel"><i class="fa fa-frown-o fa-3x"></i></button><button id="b2" type="button" value="neutral" class="btn feel"><i class="fa fa-meh-o fa-3x"></i></button><button id="b3" type="button" value="happy" class="btn feel"><i class="fa fa-smile-o fa-3x"></i></button><button id="b4" type="button" value="happy" class="btn feel"><i class="fa fa-heart-o fa-3x"></i></button><hr>'
  
  swal({
    title: "",
    text: "Cómo califica el servicio ocre?",
    icon: "info",
    className: '',
    closeOnClickOutside: false,
    content: {
      element: wrap
    },
    buttons: {
      confirm: {
        text: "OK",
        value: '',
        visible: true,
        className: "btn btn-default",
        closeModal: true,
      }
    },
  }).then((value) => {
    if(resultado==-1){this.pregunta3()}
    else {
  
        swal("Es todo...", {
          icon: "warning",
          title: "Gracias!",
           buttons: {
            confirm: {
              text: "OK",
              value: '',
              visible: true,
              className: "btn btn-default",
              closeModal: true,
            }}
      }).then(() => {
        // this.pregunta3();
  
      })
    }


  });


  $( "#b1" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b1" ).addClass("opaco");
  resultado =0;
  });

  $( "#b2" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b2" ).addClass("opaco");
  resultado =1;
  
});


$( "#b3" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b3" ).addClass("opaco");
resultado =2;
  
});


$( "#b4" ).click(function(a) { $( ".opaco" ).removeClass("opaco");  $( "#b4" ).addClass("opaco");
  
});

}


//FIN PREGUNTA 3
  add2(){
 
console.log("asasasasas");

alert();


  }

  dismiss(){
    this.viewCtrl.dismiss();

  }

cancel(){
  
    this.viewCtrl.dismiss({dato:0});

}





}


// WEBPACK FOOTER //
// ./src/pages/mis_servicios/mis_servicios.ts